interface Entry<T> { data: T; exp: number }

const store = new Map<string, Entry<unknown>>()
const inflight = new Map<string, Promise<unknown>>()

export function cached<T>(key: string, fn: () => Promise<T>, ttl = 60_000): Promise<T> {
  const hit = store.get(key) as Entry<T> | undefined
  if (hit && Date.now() < hit.exp) return Promise.resolve(hit.data)

  const pending = inflight.get(key) as Promise<T> | undefined
  if (pending) return pending

  const p = fn()
    .then(data => {
      store.set(key, { data, exp: Date.now() + ttl })
      inflight.delete(key)
      return data
    })
    .catch(err => {
      inflight.delete(key)
      throw err
    })

  inflight.set(key, p)
  return p
}

export function invalidate(...keys: string[]) {
  keys.forEach(k => store.delete(k))
}

export function invalidatePrefix(prefix: string) {
  for (const k of store.keys()) {
    if (k.startsWith(prefix)) store.delete(k)
  }
}
